import { makeStyles } from '@mui/styles';
import Radio from 'apollo-react/components/Radio';
import RadioGroup from 'apollo-react/components/RadioGroup';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../custom-hooks';
import { getUITA } from '../../../utils/commonUtils';
import { isNilOrEmpty } from '../../../utils/ramdaUtils';
import { fetchDataSource } from '../../actions/data-source.actions';
import { PREDEFINED_DATA_SOURCES } from '../../constants/form-manager.constants';
import { getDataSource } from '../../selectors/form-manager.selectors';
import { equalityFn, getOpitonsForPredefinedDataSource } from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  radio: {
    '& .Mui-disabled': {
      '& svg': {
        stroke: '#d9d9d9 !important',
      },
    },
  },
});

function SSEditorRadioButtonList({
  label,
  value,
  isRequired,
  dataSourceKey,
  dataValueField,
  dataTextField,
  dataSourceFilter,
  error,
  index,
  inFieldGroup,
  isHiddenLabel,
  formKey,
  id,
  entityName,
  fieldName,
  inTable,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const dataSource = useFormSelector(getDataSource, { dataSourceKey }, equalityFn) || {};
  const [values, setValues] = useState([]);

  const isDataSourcePredefined = PREDEFINED_DATA_SOURCES.includes(dataSourceKey);
  const hiddenLabel = (inFieldGroup && isHiddenLabel) || inTable;

  // fetch data from dataSource
  useEffect(() => {
    if (!isNilOrEmpty(dataSource) && !isDataSourcePredefined) {
      dispatch(
        fetchDataSource({
          index,
          dataSource,
          dataSourceFilter,
          dataSourceFilterFromDataSource: dataSource.filter,
          formKey,
          pageLimit: 1,
          entityName,
          isEditor: true,
        })
      ).then((vals) => {
        if (dataTextField) {
          setValues(vals.filter((item) => item[dataTextField]).slice(0, 9));
        } else {
          setValues(vals.slice(0, 9));
        }
      });
    } else {
      setValues([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(dataSource), JSON.stringify(dataSourceFilter), `${index}`]);

  // fetch data from redux store if data source is predefined
  useEffect(() => {
    if (isDataSourcePredefined) {
      const _values = getOpitonsForPredefinedDataSource(dataSource, dataSourceKey);
      setValues(_values.slice(0, 9));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{ marginTop: 16 }}
      ui-ta={getUITA('FormCtrl', 'SSRadioButtonList', entityName, fieldName)}
    >
      <RadioGroup
        id={id}
        label={hiddenLabel ? '' : label}
        value={value || ''}
        row
        required={isRequired}
        disabled
        error={error}
      >
        {values.map((item, i) =>
          isDataSourcePredefined ? (
            <Radio key={item.id} value={item.value} label={item.label} className={classes.radio} />
          ) : (
            <Radio
              key={`${item[dataTextField]}_${item[dataValueField]}_${i}`}
              value={item[dataValueField]}
              label={item.LNG_TRANSLATION || item[dataTextField]}
              className={classes.radio}
            />
          )
        )}
      </RadioGroup>
    </div>
  );
}

export default SSEditorRadioButtonList;
